import { createThunks } from 'tsx/libs/reduxUtils';
import { get } from 'tsx/libs/genericAction';
import { apiAppointments } from 'tsx/constants/api';

export const typePrefix = 'user-appointments';

const config = [{ actionType: 'getAll', apiPath: apiAppointments, method: get, actionParams: { limit: 0 } }];

export const { getAll } = createThunks(typePrefix, config);
